import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const LanguageContext = createContext(null);
const STORAGE_KEY = 'emfa.lang.v2';

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within a LanguageProvider');
  return ctx;
};

const resolveInitial = () => {
  if (typeof window === 'undefined') return 'de';
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || stored === 'de') return stored;
    const browser = (navigator.language || 'de').toLowerCase();
    return browser.startsWith('en') ? 'en' : 'de';
  } catch {
    return 'de';
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(resolveInitial);

  useEffect(() => {
    try { window.localStorage.setItem(STORAGE_KEY, language); } catch {}
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = useCallback(() => {
    setLanguage((prev) => (prev === 'en' ? 'de' : 'en'));
  }, []);

  const setLang = useCallback((lng) => {
    if (lng === 'en' || lng === 'de') setLanguage(lng);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, setLanguage: setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};
